(ns app.front.view.group.admin.standard-texts.model-codes
  (:require [app.domain.model-codes.model :as model-codes-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.table :as ui-table]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.model-codes.common :as model-codes-common]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::data :-> ::data)

(rf/reg-sub ::books
  :<- [::entities/context]
  :<- [::gas/group-id]
  (fn [[ctx group-id] _]
    (entities/find-entities ctx {:model-code-item/group group-id
                                 :entity/type           :entity.type/model-code-book})))

(rf/reg-event-fx ::save-item-alt-data
  (fn [_ [_ id edited-data]]
    {:dispatch [:comm/command-monitored {:command    :model-codes/save-item-alt-data
                                         :method     :post
                                         :data       (merge edited-data
                                                            {:id id})
                                         :notify     {:success :changes-saved}
                                         :on-success [::save-item-alt-data.success id (set (keys edited-data))]}]}))

(rf/reg-event-fx ::save-item-alt-data.success
  (fn [{:keys [db]} [_ id attrs status changes]]
    {:db       (cond-> db
                 (attrs :model-code-item/alt-content) (p/dissoc-in [::data ::alt-content-editors id]))
     :dispatch [::entities/apply-changes status changes]}))

(rf/reg-event-fx ::delete-item
  (fn [_ [_ id]]
    {:comm/command {:command    :model-codes/delete-item
                    :data       {:id id}
                    :notify     {:success :model-codes/content-deleted}
                    :on-success [::entities/apply-changes]}}))


(rf/reg-event-db ::set-editing-alt-content
  (fn [db [_ id editing?]]
    (if editing?
      (assoc-in db [::data ::alt-content-editors id ::editing?] editing?)
      (p/dissoc-in db [::data ::alt-content-editors id]))))

(rf/reg-event-db ::set-modified-alt-content
  (fn [db [_ id new-content]]
    (assoc-in db
              [::data ::alt-content-editors id ::alt-content]
              (if (ui-rt/empty-texts? new-content)
                ""
                new-content))))

(rf/reg-sub ::edited-titles
  :<- [::data]
  :-> ::edited-titles)

(rf/reg-sub ::editing-alt-content?
  :<- [::data]
  (fn [data [_ id]]
    (get-in data [::alt-content-editors id ::editing?])))

(rf/reg-sub ::modified-alt-content
  :<- [::data]
  (fn [data [_ id]]
    (get-in data [::alt-content-editors id ::alt-content])))

(defn alt-content-editor [tr {:model-code-item/keys [alt-content] :db/keys [id] :keys [content]}]
  (let [editing? (<sub [::editing-alt-content? id])]
    [:div.px-6.flex.flex-col.gap-4
     [:div
      [:div.bold.uppercase.text-xs.mb-2 (tr [:model-codes/original-text])]
      [ui-rt/editor-legacy {:id                 (str id "-content")
                            :initial-html-value content}]]
     (when (or alt-content editing?)
       [:div
        [:div.bold.uppercase.text-xs.mb-2 (tr [:model-codes/customized-text])]
        [ui-rt/editor-legacy (merge {:id (str id "-alt-content")}
                                    (if alt-content
                                      {:initial-value alt-content}
                                      {:initial-html-value content})
                                    (when editing?
                                      {:on-change #(>evt [::set-modified-alt-content id %])}))]])
     [:div.flex.justify-end
      (if editing?
        (let [modified-content (<sub [::modified-alt-content id])]
          [ui-action-buttons/save-cancel-buttons
           {:on-cancel      #(>evt [::set-editing-alt-content id false])
            :on-save        #(>evt [::save-item-alt-data id {:model-code-item/alt-content modified-content}])
            :disabled?      (<sub [:comm/command-processing? :model-codes/save-item-alt-data])
            :save-disabled? (or (nil? modified-content) (= alt-content modified-content))
            :size           :small
            :tr             tr}])
        (cc/button {:type     :button
                    :kind     :tertiary
                    :size     :small
                    :on-click #(>evt [::set-editing-alt-content id true])}
                   (tr [(if alt-content
                          :model-codes/edit-customized
                          :model-codes/add-customized)])))]]))

(defn content-table [{:keys [tr expanded-row-keys] :as ctx} parent-id]
  (let [items (<sub [::model-codes-common/item-children parent-id])]
    [ui-table/modern-responsive-table
     {:cols              [[:model-code-item/title
                           model-codes-model/model-code-item-label-with-ordinal]]
      :tr                tr
      :items             items
      :expanded-func     (fn [{:keys [content] :db/keys [id] :as item}]
                           (let [children (seq (model-codes-model/item-children item))]
                             (cond
                               children
                               [:div.pl-6
                                [content-table ctx id]]
                               content
                               [alt-content-editor tr item])))
      :expanded-row-keys expanded-row-keys
      :on-expand         #(>evt [::model-codes-common/toggle-row-expansion %])
      :make-actions      (fn [{:db/keys [id] :model-code-item/keys [title]}]
                           [{:title           (tr [:delete])
                             :icon            i/trash
                             :confirm?        true
                             :confirm-content (tr [:model-codes/delete-confirm]
                                                  [title])
                             :on-click        #(>evt [::delete-item id])}])}]))

(defn section []
  (let [tr               (<sub [::gas/group-tr])
        group-id         (<sub [::gas/group-id])
        books            (<sub [::books])
        books-loading?   (<sub [::model-codes-common/books-loading?])
        selected-book    (<sub [::model-codes-common/selected-book])
        content-loading? (<sub [:comm/command-processing? :model-codes/group-selections-for-book])
        book-sections    (<sub [::model-codes-common/selected-book-sections])]
    [acommon/section {}
     (cond
       books-loading?
       (cc/loading-spinner {:with-overlay false})

       (empty? books)
       [:div (tr [:model-codes/no-books-downloaded])]

       :else
       [:<>
        [ui/help (tr [:model-codes/manage-codes-info])]
        [model-codes-common/model-code-search tr group-id books]

        (when selected-book
          (cond
            (seq book-sections)
            [content-table {:tr tr :expanded-row-keys (<sub [::model-codes-common/expanded-rows])} (:db/id selected-book)]

            content-loading?
            (cc/loading-spinner {:with-overlay false})

            :else
            [:div (tr [:model-codes/no-book-content])]))])]))
